/**
 * WFS solar_module VectorLayer에서 solar_module_seq로 피처 검색
 * @param {import('ol/layer/Vector').default|null|undefined} vectorLayer
 * @param {number|string|null|undefined} solarModuleSeq
 * @returns {import('ol/Feature').default|null}
 */
export function findSolarModuleFeatureInLayer(vectorLayer, solarModuleSeq) {
  if (vectorLayer == null || solarModuleSeq == null || solarModuleSeq === '') {
    return null;
  }
  const source = vectorLayer.getSource?.();
  if (!source) {
    return null;
  }
  const key = String(solarModuleSeq);
  const features = source.getFeatures?.() || [];
  return (
    features.find(f => {
      const props = f.getProperties?.() || {};
      const seq = props.solar_module_seq ?? props.module_id ?? props.solarModuleSeq;
      return seq != null && String(seq) === key;
    }) || null
  );
}
